import { Component, signal, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';

import * as xlsx from 'xlsx';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { MainComponent } from 'src/app/components/main/main.component';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';
import { AdministradorService } from 'src/app/services/administrador/administrador.service';

import { RolModel } from 'src/app/services/sso/models/rol.model';
import { UsuarioModel } from 'src/app/services/sso/models/usuario.model';
import { TareaModel } from 'src/app/services/administrador/models/tarea.model';

import { EditTareaComponent } from '../edit-tarea/edit-tarea.component';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { Utils } from 'src/app/utils/utils';
import { VersionService } from 'src/app/services/version/version.service';
import { VersionModel } from 'src/app/services/version/models/version.model';
import { RendererUtils } from 'src/app/utils/RendererUtils';
import { WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-listado-tareas',
  templateUrl: './listado-tareas.component.html',
  styleUrls: ['./listado-tareas.component.css']
})
export class ListadoTareasComponent implements AfterViewInit {
  @ViewChild('ventana') public window: WindowComponent;
  @ViewChild('gridJobs') public gridJobs: jqxGridComponent;
  @ViewChild('formJob', { read: ViewContainerRef }) public editTareaComponent;
  @ViewChild('header') public header: HeaderComponent;

  protected actions = [{type: "button", action:"cancel", value: "", label: this.translate('Salir')}];

  public static _this: ListadoTareasComponent;
  private componentRef = null;
  protected environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public windowTitle = signal<string>(AppComponent.translate('Jobs') + ' V 0.0.0 (0)');

  public jobsList: TareaModel[] = [];
  public version: VersionModel;

  private rowIndex = -1;
  public jobSelect: TareaModel;
  public formJob;

  public usuario: UsuarioModel;
  public rol: RolModel;

  public editable = false;
  public loading = signal(false);

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private administradorService: AdministradorService,
    private versionService: VersionService,
    private ssoService: SsoService,
  ) {
    ListadoTareasComponent._this = this;
  }

  public init(componentRef: unknown): void {
    this.usuario = this.ssoService.getTicket().Usuario;
    this.rol = this.ssoService.getTicket().Rol;
    this.componentRef = componentRef;
  }

  public async ngAfterViewInit(): Promise<void> {
    this.loading.set(true);
    await this.getVersion();

    await this.getJobs();

    if (this.usuario.Interno && this.rol.Nombre === 'Administrador') {
      this.editable = true;
    }

    this.initGridJobs();
  }

  public onExpand(): void {
    this.sourceJobs.localdata = this.jobsList;
    this.gridJobs.updatebounddata('data');

    this.resizeColumns();
  }

  public resizeColumns(): void {
    Utils.renderSizeGrid(this.gridJobs, 300, ['acciones']);
  }

  public closeWindow(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    this.window.ngOnDestroy();
    ListadoTareasComponent._this = null;
  }

  public actionButtonClicked(event): void {
    if(event.action === 'cancel') {
      this.closeWindow();
      return;
    }
  }

  public async getVersion(): Promise<void> {
    try {
      this.version = await this.versionService.getVersionJobs();
    }
    catch (e) {
      console.error(e);
     }
  }

  public async getJobs(): Promise<void> {
    try {
      this.administradorService.getTareas().then(
        async (result: TareaModel[]) => {
          this.jobsList = result;

          this.sourceJobs.localdata = this.jobsList;
          this.adapterJobs = new jqx.dataAdapter(this.sourceJobs);
          this.gridJobs.updatebounddata('data');

          this.resizeColumns();
          this.loading.set(false);
        }
      )
    }
    catch (e) {
      this.jobsList = [];
    }
  }

  /* GRID JOBS */
  /*
    Comprueba si la tarea esta activada o no
    y marca el check en el listado
  */
  public renderCheckColumn = (row: number, columnfield: string, value: string | number, defaulthtml: string, columnproperties: unknown, rowdata: unknown): string => {
    if (value == 1 || value) {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">Si</div>';
    }
    else {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">No</div>';
    }
  };

  public columnsJobs;

  public sourceJobs = {
    datatype: 'json',
    groupsrenderer: this.groupsrenderer,
    datafields: [
      { name: 'id', type: 'int', map: 'id' },
      { name: 'acciones', type: 'string' },
      { name: 'nombre', type: 'string', map: 'nombre' },
      { name: 'nombreTrigger', type: 'string', map: 'nombreTrigger' },
      { name: 'grupo', type: 'string', map: 'grupo' },
      { name: 'segundos', type: 'int', map: 'segundos' },
      { name: 'cronExpresion', type: 'string', map: 'cronExpresion' },
      { name: 'activado', type: 'boolean', map: 'activado' },
      { name: 'descripcion', type: 'string', map: 'descripcion' },
      { name: 'selec', map: 'selec' }
    ],
    localdata: [],
  };
  public adapterJobs = new jqx.dataAdapter(this.sourceJobs);

  public initGridJobs(): void {
    this.columnsJobs = [
      { text: 'id', columntype: 'textbox', datafield: 'id', width: 1, hidden: true },
      {
        hidden: !this.editable,
        text: this.translate('Acciones'),
        width: 50,
        columntype: 'text',
        sortable: false,
        editable: false,
        datafield: 'acciones',
        groupable: false,
        menu: false,
        rendered: (columnHeaderElement): void => {
          return columnHeaderElement[0];
        },
        createwidget: (
          row: unknown,
          column: unknown,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
        initwidget: (
          row: unknown,
          column: unknown,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        }
      },
      { text: this.translate('Nombre'), columntype: 'text', datafield: 'nombre', width: 200, editable: false, cellclassname: this.cellClass, },
      { text: 'Trigger', columntype: 'textbox', datafield: 'nombreTrigger', width: 250, editable: false, cellclassname: this.cellClass },
      { text: this.translate('Grupo'), columntype: 'textbox', datafield: 'grupo', width: 200, editable: false, cellclassname: this.cellClass },
      { text: this.translate('Segundos'), columntype: 'textbox', datafield: 'segundos', width: 70, cellsrenderer: RendererUtils.numberrenderer, editable: this.editable, cellclassname: this.cellClass },
      { text: this.translate('Expresion_cron'), columntype: 'textbox', datafield: 'cronExpresion', width: 100, editable: this.editable, cellclassname: this.cellClass },
      {
        text: this.translate('Activa'), columntype: 'checkbox', datafield: 'activado', width: 40, editable: this.editable,
        filtertype: 'checkedlist',
        filteritems: [
          this.translate('SI'),
          this.translate('NO')
        ],
      },
      { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', width: 600, editable: this.editable, cellclassname: this.cellClass },
      { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true }
    ];

    let isFirstIteration = true;
    this.columnsJobs.forEach(column => {
      if (!isFirstIteration) {
        column.rendered = (element): void => { Utils.tooltiprenderer(element) };
      } else {
        isFirstIteration = false;
      }
    });
  }

  public cellClass = (row: number, columnfield: unknown, value: unknown): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  public updatefilterconditions = (type: string, defaultconditions: unknown): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: unknown, rowData?: unknown, dataField?: string, filterGroup?: unknown, defaultFilterResult?: boolean): unknown {
    const filterColumns = [
      'nombre',
      'nombreTrigger',
      'grupo',
      'descripcion'
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  // Incializa la columna de botones
  public async initBtnColumn(
    row: unknown,
    column: unknown,
    value: string,
    htmlElement: HTMLElement
  ): Promise<void> {
    let jobId;
    /*
      Necesitamos hacer una conversion a any de row
      para acceder a sus propiedades y para que no
      de error el eslint desactivamos esta regla
      para este caso especifico
    */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const gridRow = (row as any);

    if(gridRow.bounddata?.id) {
      jobId = gridRow.bounddata.id
    }else {
      const dataRow = this.gridJobs.getrowdatabyid(gridRow);
      jobId = dataRow.id;
    }

    htmlElement.innerHTML = '';
    // Crea un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'space-around';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    const btnEdit = document.createElement('div');
    btnEdit.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Editar') + `">
          <i class="fa-solid fa-pen-to-square"></i>
        </button>
      `;
    btnEdit.id = `buttonEdit_jqxButton`;
    btnContainer.appendChild(btnEdit);

    btnEdit.addEventListener('click', () => {
      this.jobSelect = this.jobsList.find(job => job.id === jobId);
      this.clickOnEdit();
    });

    htmlElement.appendChild(btnContainer);
  }

  public clickOnEdit(): void {
    this.onEditarJob();
  }

  public groupsrenderer(text?: string, group?, expanded?: boolean, data?): string {
    let showText = `
      <div style="top: 50%; margin-top: -8px; position: relative; margin-left: 4px">
        <b>`+ AppComponent.translate('Activa') + `: </b>
    `;

    //Renderiza los grupos de tipo booleano con el texto para cada idioma
    if (group === true) {
      showText += AppComponent.translate('SI');
      if (data.subGroups.length == 0) {
        showText += '(' + data?.subItems.length + ')';
      } else {
        showText += '(' + data?.subGroups.length + ')';
      }
      return showText;
    } else if (group === false) {
      showText += AppComponent.translate('NO');
      if (data.subGroups.length == 0) {
        showText += '(' + data?.subItems.length + ')';
      } else {
        showText += '(' + data?.subGroups.length + ')';
      }
      return showText + `</div>`;
    }
  }

  /* Acciones del grid */
  public onCellClick(event): void {
    if (!event.args.column.editable && event.args.column.datafield !== 'acciones') {
      if (this.rowIndex != event.args.rowindex) {
        this.rowIndex = event.args.rowindex;
        this.jobSelect = this.jobsList[event.args.rowindex];
      } else if (this.rowIndex === event.args.rowindex) {
        this.rowIndex = null;
        this.jobSelect = null;
      }
    }
  }

  public onRowdoubleclick(event): void {
    if (this.editable) {
      this.rowIndex = event.args.rowindex;
      this.jobSelect = this.jobsList[event.args.rowindex];
      this.gridJobs.selectrow(this.rowIndex);

      this.onEditarJob();
    }
  }

  public onEditarJob(): void {
    if (this.jobSelect) {
      this.jobSelect = this.jobsList.find(job => job.id === this.jobSelect.id);
      this.formJob = this.editTareaComponent.createComponent(EditTareaComponent);
      this.formJob.instance.init(this.formJob, this.jobSelect);

      this.window.collapseWindow();
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  public onCellvaluechanged(event): void {
    const fila = this.gridJobs.getrowdata(event.args.rowindex);
    const index = this.jobsList.findIndex(job => job.id === fila.id);

    this.updateTarea(fila, index);
  }

  public onBindingComplete(): void {
    this.onGridDataUpdated();
  }

  public onFilter(event): void {
    // Itero a través de todos los filtros aplicados
    for (const filterObj of event.args.filters) {
      const column = filterObj.datafield;
      const filter = filterObj.filter.getfilters();

      if (column === 'activado') {
        let filter1;
        filter.forEach(filt => {
          const filtergroup = new jqx.filter();
          const filter_operator = filt.operator;
          const filtercondition = filt.condition;
          let filtervalue;

          if (filt.value === this.translate('SI')) {
            filtervalue = true;
          } else if (filt.value === this.translate('NO')) {
            filtervalue = false;
          }

          if (filtervalue != undefined) {
            filter1 = filtergroup.createfilter('booleanfilter', filtervalue, filtercondition);
            filtergroup.addfilter(filter_operator, filter1);
            this.gridJobs.addfilter(column, filtergroup);
            this.gridJobs.applyfilters();

            filter1 = filtergroup.createfilter('stringfilter', filt.value, filtercondition);
            filtergroup.addfilter(filter_operator, filter1);
            this.gridJobs.addfilter(column, filtergroup);
          }
        });
      }
    }
    this.onGridDataUpdated();
  }

  public async updateTarea(tarea: TareaModel, index: number): Promise<void> {
    const actualizado = await this.administradorService.updateTarea(tarea);

    if (actualizado !== null) {
      MainComponent.getInstance().showInfo(
        'ATENCION',
        'Registro_almacenado',
        2000
      );
      this.jobsList[index] = tarea;
    } else {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Fallo_almacenar_info',
        2000
      );
    }
  }

  public eventFilter(): void {
    this.header.searchInput['nativeElement'].value = '';
    this.getJobs();
  }

  public eventResetFilter(): void {
    this.header.searchInput['nativeElement'].value = '';
    this.onBuscar();
  }

  public onBuscar(): void {
    let filtervalue = '';

    if (this.header.searchInput['nativeElement'].value.length >= 3) {
      filtervalue = this.header.searchInput['nativeElement'].value.toUpperCase();
    } else {
      filtervalue = '';
    }

    this.jobsList.forEach(job => {
      if (
        (job?.nombre + '').compareWith(filtervalue) ||
        (job?.nombreTrigger + '').compareWith(filtervalue) ||
        (job?.grupo + '').compareWith(filtervalue) ||
        (job?.segundos + '').compareWith(filtervalue) ||
        (job?.cronExpresion + '').compareWith(filtervalue) ||
        (job?.descripcion + '').compareWith(filtervalue)
      ) {
        job['selec'] = 'selec';
      } else {
        job['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.gridJobs.getfilterinformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.gridJobs.addfilter('selec', filtergroup);
    }
    this.gridJobs.applyfilters();
    this.gridJobs.updatebounddata('data');
  }

  public onExportar(): void {
    const json = JSON.parse(JSON.stringify(this.gridJobs.getdisplayrows()));
    /*
      Elimino los campos que no se quieren mostrar en el excel
    */
    json.forEach(element => {
      delete element.id;
      delete element.uid;
      delete element.uniqueid;
      delete element.visibleindex;
      delete element.boundindex;
      delete element.dataindex;
      delete element.selec;

      if (element.activado) {
        element.activado = AppComponent.translate('SI');
      } else {
        element.activado = AppComponent.translate('NO');
      }
    });

    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(json);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_' + AppComponent.translate('Jobs') + '.xlsx');
  }

  public onGridDataUpdated(): void {
    this.__updateWindowTitle(this.gridJobs.getrows().length, this.version);
  }

  private __updateWindowTitle(countJobs: number, version: VersionModel): void {
    this.windowTitle.set(AppComponent.translate('Jobs') + ' V' + (version ? version.version : '0') +' ('+countJobs+')')
  }
}
